'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _config = require('../../config.js');

var _BriefcaseSVG = require('../../svg/BriefcaseSVG');

var _BriefcaseSVG2 = _interopRequireDefault(_BriefcaseSVG);

var _GradCapSVG = require('../../svg/GradCapSVG');

var _GradCapSVG2 = _interopRequireDefault(_GradCapSVG);

var _ScalesSVG = require('../../svg/ScalesSVG');

var _ScalesSVG2 = _interopRequireDefault(_ScalesSVG);

var _OhioLogoOutlineSVG = require('../../svg/OhioLogoOutlineSVG');

var _OhioLogoOutlineSVG2 = _interopRequireDefault(_OhioLogoOutlineSVG);

var _Wrapper = require('./components/Wrapper');

var _Wrapper2 = _interopRequireDefault(_Wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconDivider = function IconDivider(_ref) {
  var _ref$hasTopMargin = _ref.hasTopMargin,
      hasTopMargin = _ref$hasTopMargin === undefined ? true : _ref$hasTopMargin,
      _ref$hasBottomMargin = _ref.hasBottomMargin,
      hasBottomMargin = _ref$hasBottomMargin === undefined ? true : _ref$hasBottomMargin,
      iconType = _ref.iconType,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? _config.colors.darkBlue : _ref$color;

  /* eslint-disable */
  // throws an error for react/display-name
  // we want to use the display name for the actual component that is being returned
  var IconMap = {
    Briefcase: _BriefcaseSVG2.default,
    GraduationCap: _GradCapSVG2.default,
    JusticeScales: _ScalesSVG2.default,
    Logo: _OhioLogoOutlineSVG2.default
  };
  /* eslint-enable */
  var ColorMap = {
    red: _config.colors.red,
    blue: _config.colors.darkBlue,
    gray: _config.colors.lightGray
  };

  var Icon = IconMap[iconType] || IconMap.Logo;
  var IconColor = ColorMap[color] || ColorMap.blue;

  return _react2.default.createElement(
    _Wrapper2.default,
    {
      $hasTopMargin: hasTopMargin,
      $hasBottomMargin: hasBottomMargin
    },
    _react2.default.createElement(Icon, {
      height: '35px',
      color: IconColor
    })
  );
};

IconDivider.propTypes = {
  /** Whether or not a 30px bottom margin is applied. */
  hasBottomMargin: _propTypes2.default.bool,
  /** Whether or not a 30px top margin is applied. */
  hasTopMargin: _propTypes2.default.bool,
  /** The icon SVG to use. */
  iconType: _propTypes2.default.oneOf(['Briefcase', 'GraduationCap', 'JusticeScales', 'Logo']).isRequired,
  /** The color of the icon SVG. */
  color: _propTypes2.default.string
};

IconDivider.displayName = 'IconDivider';

exports.default = IconDivider;
IconDivider.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'IconDivider',
  'props': {
    'hasTopMargin': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether or not a 30px top margin is applied.'
    },
    'hasBottomMargin': {
      'defaultValue': {
        'value': 'true',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether or not a 30px bottom margin is applied.'
    },
    'color': {
      'defaultValue': {
        'value': 'colors.darkBlue',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The color of the icon SVG.'
    },
    'iconType': {
      'type': {
        'name': 'enum',
        'value': [{
          'value': '\'Briefcase\'',
          'computed': false
        }, {
          'value': '\'GraduationCap\'',
          'computed': false
        }, {
          'value': '\'JusticeScales\'',
          'computed': false
        }, {
          'value': '\'Logo\'',
          'computed': false
        }]
      },
      'required': true,
      'description': 'The icon SVG to use.'
    }
  }
};